<template>
  <div class="lives_main">
    <header>
      <div class="banner" :class="{ large: windowWidth > 1920 }" />
      <div class="logo_block">
        <img
          v-if="siteLabel"
          class="home_button"
          src="@/assets/lives/home.png"
          @click="openHome()"
        />
        <img v-else class="super_button" src="@/assets/lives/super.png" @click="openHome()" />
      </div>
      <div class="toolbar">
        <div class="title">{{ activeCat ? cats[activeCat].Name : $t('lives.all') }}</div>
        <div class="cat_select" :class="{ options: catOptionsShow }" @click="showCatOptions()">
          <div class="cat">
            <img class="icon" :src="require(`@/assets/lives/cats/${activeCat}.svg`)" />
            <span class="name">{{ activeCat ? cats[activeCat].Name : $t('lives.all') }}</span>
          </div>
        </div>
      </div>
    </header>
    <section
      v-if="catOptionsShow"
      ref="cat_options_bg"
      class="cat_options_bg"
      @click="hideCatOptions($event)"
    >
      <div class="cat_options">
        <div
          :key="0"
          class="cat_option"
          :class="{ active: 0 === activeCat }"
          @click="mySetActiveCat(0)"
        >
          <img class="icon" :src="require(`@/assets/lives/cats/0.svg`)" />
          <span class="name">{{ $t('lives.all') }}</span>
        </div>
        <div
          v-for="cat in activeCats"
          :key="cat"
          class="cat_option"
          :class="{ active: cat === activeCat }"
          @click="mySetActiveCat(cat)"
        >
          <img class="icon" :src="require(`@/assets/lives/cats/${cat}.svg`)" />
          <span class="name">{{ cats[cat].Name }}</span>
        </div>
      </div>
    </section>
    <main>
      <ul>
        <li v-for="live in activeLives" :key="live.EvtID">
          <div class="catleague">
            <span
              class="icon"
              :style="{
                mask: 'url(' + require(`@/assets/lives/cats/${live.CatID}.svg`) + ')',
              }"
            />
            <span class="cat">{{ live.CatName }}</span>
            <span class="league">{{ live.LeagueName }}</span>
          </div>
          <div class="time">{{ live.ScheduleTimeStr.substr(0, 16) }}</div>
          <div class="status" :class="{ now: live.IsRun }">{{
            live.IsRun ? $t('lives.now') : $t('lives.yet')
          }}</div>
          <template
            v-if="
              live.HomeTeamStr &&
              live.HomeTeamStr !== '.' &&
              live.AwayTeamStr &&
              live.AwayTeamStr !== '.'
            "
          >
            <div class="team home">
              <span class="name">{{ live.HomeTeamStr }}</span>
              <img
                v-if="live.HomeImage"
                class="logo"
                :src="`/timage/${live.HomeImage}`"
                onerror="javascript:this.src='/img/no.png'"
              />
            </div>
            <img class="vs" src="@/assets/lives/vs.png" />
            <div class="team away">
              <img
                v-if="live.AwayImage"
                class="logo"
                :src="`/timage/${live.AwayImage}`"
                onerror="javascript:this.src='/img/no.png'"
              />
              <span class="name">{{ live.AwayTeamStr }}</span>
            </div>
          </template>
          <div class="actions">
            <div class="bet" @click="openTable(live)">{{ $t('lives.bet') }}</div>
            <div v-if="live.IsRun" class="view" @click="showLive(live)">{{ $t('lives.view') }}</div>
          </div>
        </li>
      </ul>
    </main>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

  export default {
    props: {
      windowWidth: {
        type: Number,
        default: 1024,
      },
    },
    data() {
      return {
        catOptionsShow: false,
      };
    },
    computed: {
      ...mapState(['siteLabel']),
      ...mapState('Lives', ['cats', 'activeCats', 'activeCat']),
      ...mapGetters('Lives', ['activeLives']),
    },
    methods: {
      ...mapMutations('Lives', ['setActiveCat', 'showLive']),
      ...mapActions('Lives', ['openHome', 'openTable']),
      showCatOptions() {
        this.catOptionsShow = true;
      },
      hideCatOptions(event) {
        if (event.target === this.$refs.cat_options_bg) {
          this.catOptionsShow = false;
        }
      },
      mySetActiveCat(cat) {
        this.setActiveCat(cat);
        this.catOptionsShow = false;
      },
    },
  };
</script>

<style lang="scss">
  .lives_main {
    display: flex;
    flex-flow: column nowrap;
    width: 100%;
    height: 100%;
    color: #868686;
    font-size: 13px;

    > header {
      position: relative;

      > .banner {
        width: 100%;
        height: 180px;
        background-image: url('~@/assets/lives/wbsc.jpg');
        background-size: cover;
        background-position: center;

        &.large {
          height: 9.375vw;
        }
      }

      > .logo_block {
        position: absolute;
        width: 100%;
        left: 0;
        top: 0;
        padding: 6px 32px 4px;
        background-color: rgba(0, 0, 0, 0.7);

        > .home_button {
          width: 32px;
          cursor: pointer;
          filter: brightness(0.9);

          &:hover {
            filter: brightness(1);
          }
        }

        > .super_button {
          width: 18vw;
          cursor: pointer;
          filter: brightness(0.9);

          &:hover {
            filter: brightness(1);
          }
        }
      }

      > .toolbar {
        position: relative;
        height: 64px;
        box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.1);
        background-color: #fff;

        > .title {
          position: absolute;
          left: 8vw;
          top: 50%;
          transform: translateY(-50%);
          color: #00a2ad;
          font-size: 16px;
          font-weight: bold;
        }

        > .cat_select {
          position: absolute;
          width: 160px;
          height: 40px;
          right: 4vw;
          top: 50%;
          transform: translateY(-50%);
          border: 1px solid #fff;
          border-radius: 8px;
          font-size: 18px;
          cursor: pointer;

          > .cat {
            display: flex;
            flex-flow: row nowrap;
            align-items: center;
            gap: 6px;
            height: 100%;
            padding-left: 8px;
            background-color: #00a8bf;
            border-radius: 8px;

            > .icon {
              width: 20px;
            }

            > .name {
              color: #fff;
            }
          }

          &:after {
            position: absolute;
            width: 16px;
            height: 10px;
            right: 16px;
            top: 50%;
            transform: translateY(-50%);
            background-color: #eee;
            clip-path: polygon(100% 0%, 0 0%, 50% 100%);
            font-size: 18px;
            transition: transform 0.2s ease-in-out 0.2s, background-color 0.1s ease-in-out 0.1s;
            content: '';
          }

          &.options {
            &:after {
              background-color: #fff;
              transform: translateY(-50%) rotate(-90deg);
            }
          }
        }
      }
    }

    > .cat_options_bg {
      position: fixed;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 10;
      background-color: rgba(0, 0, 0, 0.64);

      > .cat_options {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-auto-rows: 40px;
        grid-column-gap: 8px;
        grid-row-gap: 8px;
        position: absolute;
        width: 80%;
        max-width: 480px;
        left: 50%;
        top: calc(50%);
        transform: translate(-50%, -50%);
        padding: 16px;
        border: 2px solid #aaa;
        border-radius: 8px;
        box-shadow: 2px 4px 8px 0 rgba(0, 0, 0, 0.4);
        background-color: #eee;

        > .cat_option {
          display: flex;
          flex-flow: row nowrap;
          align-items: center;
          justify-content: center;
          gap: 6px;
          border-radius: 8px;
          background-color: #00a8bf;
          cursor: pointer;

          > .icon {
            width: 20px;
          }

          > .name {
            color: #eee;
            font-size: 16px;
          }

          &.active {
            background-color: #0082ab;

            > .name {
              color: #fff;
              font-weight: bold;
            }
          }

          &:hover {
            background-color: #0082ab;

            > .name {
              color: #fff;
            }
          }
        }
      }
    }

    > main {
      flex-grow: 1;
      flex-shrink: 1;
      width: 100%;
      padding: 24px 4vw;
      background-color: #e3ebee;

      > ul {
        > li {
          display: flex;
          flex-flow: row nowrap;
          position: relative;
          width: 100%;
          height: 128px;
          margin-bottom: 16px;
          border-radius: 8px;
          box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.2);
          background-color: #fff;

          > .catleague {
            display: flex;
            flex-flow: row nowrap;
            align-items: center;
            position: absolute;
            left: 16px;
            top: 24%;
            transform: translateY(-50%);
            color: #868686;
            font-size: 13px;

            > .icon {
              display: inline-block;
              width: 20px;
              height: 20px;
              margin-right: 4px;
              background-color: #0082ab;
            }

            > .cat {
            }

            > .league {
              &::before {
                margin-left: 4px;
                margin-right: 4px;
                font-size: 16px;
                content: '-';
              }
            }
          }

          > .time {
            position: absolute;
            left: 16px;
            top: 64%;
            transform: translateY(-50%);
            padding: 8px 16px;
            border: 1px solid #c7c7c7;
            border-radius: 8px;
          }

          > .status {
            position: absolute;
            left: 50%;
            top: 24%;
            transform: translate(-50%, -50%);
            padding: 2px 8px 4px;
            border-radius: 16px;
            background-color: #d0e5e8;
            color: #657274;

            &.now {
              background-color: #75efbc;
              font-weight: bold;

              &::before {
                display: inline-block;
                position: relative;
                width: 14px;
                height: 14px;
                top: 2px;
                margin-right: 4px;
                background-image: url('~@/assets/lives/live.svg');
                background-size: contain;
                background-position: center;
                background-repeat: no-repeat;
                content: '';
                animation: now 1s ease-in-out 0s infinite alternate;
              }
            }
          }

          > .team {
            display: flex;
            flex-flow: row nowrap;
            align-items: center;
            position: absolute;
            top: 64%;
            transform: translateY(-50%);

            > .name {
              margin-left: 8px;
              margin-right: 8px;
              font-size: 15px;
              font-weight: bold;
              color: #868686;
            }

            > .logo {
              width: 32px;
            }

            &.home {
              right: calc(50% + 24px);
            }

            &.away {
              left: calc(50% + 24px);
            }
          }

          > .vs {
            position: absolute;
            width: 40px;
            left: 50%;
            top: 64%;
            transform: translate(-50%, -50%);
          }

          > .actions {
            display: flex;
            flex-flow: row nowrap;
            align-items: center;
            position: absolute;
            right: 20px;
            top: 64%;
            transform: translateY(-50%);

            > .bet {
              padding: 4px 15px 6px;
              border: 1px solid #00a2ad;
              border-radius: 8px;
              color: #00a2ad;
              font-weight: bold;
              white-space: nowrap;
              cursor: pointer;

              &:hover {
                box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.24);
              }
            }

            > .view {
              margin-left: 8px;
              padding: 4px 15px 6px;
              border: 1px solid #00a8bf;
              border-radius: 8px;
              background-color: #00a8bf;
              color: #fff;
              font-weight: bold;
              white-space: nowrap;
              cursor: pointer;

              &:hover {
                box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.24);
              }
            }
          }
        }
      }
    }

    @keyframes now {
      100% {
        transform: scale(1.2);
      }
    }
  }
</style>
